module.exports = __webpack_public_path__ + "public/img/qianzi.a32dc1b2.png";